// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "./theme.css"; // your glass theme overrides
import "./index.css"; // base styles last

import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // NOTE: StrictMode dev-ல் effects 2 times run ஆகும் (animation/jitter feel).
  // If you want smoother dev experience, remove StrictMode.
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

// ✅ PWA install support (register service worker from /public/sw.js)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}